var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsChartTypesTable = function SvgIconsChartTypesTable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22 19c0 1.598-1.249 2.904-2.824 2.995L19 22H5c-1.598 0-2.904-1.249-2.995-2.824L2 19V5c0-1.598 1.249-2.904 2.824-2.995L5 2h14c1.598 0 2.904 1.249 2.995 2.824L22 5v14zM4 8v11c0 .513.386.936.883.993L5 20h2V8H4zm16 0H9v12h10c.513 0 .936-.386.993-.883L20 19V8zm-1-4H9v2h11V5c0-.513-.386-.936-.883-.993L19 4zM4 6h3V4H5c-.513 0-.936.386-.993.883L4 5v1z"
  })));
};
export default SvgIconsChartTypesTable;